import { ContentLanguage, Language, CurrencyCode } from 'codegen/types'

export const languageMap = new Map<Language, string>([
  [Language.En, 'English'],
  [Language.Es, 'Español'],
  [Language.De, 'Deutsch'],
  [Language.Pt, 'Português (BR)'],
  [Language.Fr, 'Français'],
  [Language.It, 'Italiano'],
  [Language.Nl, 'Nederlands'],
  [Language.Pl, 'Polski'],
])

// oxlint-disable-next-line unicorn/prefer-spread
export const supportedLanguages = Array.from(languageMap.keys())

export const defaultLanguage = Language.En

export const defaultCurrency = {
  code: CurrencyCode.Usd,
  symbol: '$',
}

export const defaultContentLanguage = ContentLanguage.LanguageEn

export const mapLocaleToContentLanguage = new Map<string, ContentLanguage>([
  [Language.En, ContentLanguage.LanguageEn],
  [Language.Es, ContentLanguage.LanguageEs],
  [Language.De, ContentLanguage.LanguageDe],
  [Language.Fr, ContentLanguage.LanguageFr],
  [Language.It, ContentLanguage.LanguageIt],
  [Language.Nl, ContentLanguage.LanguageNl],
  [Language.Pt, ContentLanguage.LanguagePtBr],
  [Language.Pl, ContentLanguage.LanguagePl],
])

export const mapContentLanguageToLocale = new Map<ContentLanguage, string>([
  [ContentLanguage.LanguageEn, Language.En],
  [ContentLanguage.LanguageEs, Language.Es],
  [ContentLanguage.LanguageDe, Language.De],
  [ContentLanguage.LanguageFr, Language.Fr],
  [ContentLanguage.LanguageIt, Language.It],
  [ContentLanguage.LanguageNl, Language.Nl],
  [ContentLanguage.LanguagePtBr, Language.Pt],
  [ContentLanguage.LanguagePl, Language.Pl],
])

export const mapLocaleToLanguageCode = new Map<Language, string>([
  [Language.En, 'en-US'],
  [Language.Es, 'es-ES'],
  [Language.De, 'de-DE'],
  [Language.Fr, 'fr-FR'],
  [Language.It, 'it-IT'],
  [Language.Nl, 'nl-NL'],
  [Language.Pt, 'pt-BR'],
  [Language.Pl, 'pl-PL'],
])
